import React, { createContext, useState, useContext, useEffect } from 'react';

import moment from 'moment';

import { PacksContext } from './ApiProvider';

const AssignContext = createContext(undefined);
const AssignDispatchContext = createContext(undefined);

function AssignProvider(props) {
    const { venues, packs, forceUpdateTop } = useContext(PacksContext);
    const [selectedVenue, setSelectedVenue] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedSchedules, setSelectedSchedules] = useState(false);
    const [selectedPack, setSelectedPack] = useState(false);
    const [selectedAmount, setSelectedAmount] = useState(0);
    const [formattedDate, setFormattedDate] = useState(null);
    const [formattedDates, setFormattedDates] = useState([]);
    const [filterDay, setFilterDay] = useState(false);
    const [filterDays, setFilterDays] = useState([]);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [filteredPacks, setFilteredPacks] = useState([]);

    const assignAction = (action, details = false) => {
        switch (action) {
            case 'selectPack':
                selectPack(details);
                break;
            case 'selectVenue':
                selectVenue(details);
                break;
            case 'selectDate':
                selectDate(details);
                break;
            case 'selectDates':
                selectDates(details);
                break;
            case 'clearDates':
                clearDates(details);
                break;
            case 'selectOnlyFirstDate':
                selectOnlyFirstDate(details);
                break;
            case 'selectSchedules':
                selectSchedules(details);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        const vId = localStorage.getItem('localselectedVenue');
        let ven = venues.find((v) => v.id == vId);
        if (ven) {
            setSelectedVenue(() => {
                return JSON.parse(JSON.stringify(ven));
            });
        }
    }, [venues]);

    useEffect(() => {
        selectedDates.forEach((val) => {
            setFilteredPacks(() => {
                const newFilteredPacks = [];
                if (selectedVenue && packs && selectedVenue.expense_packs.length && packs.length) {
                    for (let i = 0; i < selectedVenue.expense_packs.length; i++) {
                        const dates = selectedVenue.expense_packs[i].pivot.amount;
                        const details = selectedVenue.expense_packs[i].pivot.details;
                        const customizations = selectedVenue.expense_packs[i].pivot.customizations || {};

                        const packObj = {
                            packId: selectedVenue.expense_packs[i].id,
                            allDetails: [],
                            allCustomizations: [],
                            allAmountData: [],
                            allAmount: 0,
                        };

                        let push = false;
                        selectedDates.forEach((val) => {
                            const formD = moment(val);
                            const fd = formD.format('YYYY-MM-DD');

                            if (Object.prototype.hasOwnProperty.call(dates, fd)) {
                                const packExists = packs.find((p) => p.id == selectedVenue.expense_packs[i].id);
                                if (packExists) {
                                    push = true;

                                    packObj.amount = dates[fd];
                                    packObj.details = details[fd];
                                    packObj.customizations = customizations[fd] || {};
                                    packObj.allDetails.push(details[fd]);
                                    packObj.allCustomizations.push(customizations[fd] || {});
                                    packObj.allAmountData.push(dates[fd]);
                                    packObj.allAmount += dates[fd];
                                }
                            }
                        });

                        if (push) {
                            newFilteredPacks.push(packObj);
                        }
                    }
                }
                return newFilteredPacks;
            });
        });

        if (selectedDates.length === 0) {
            setFilteredPacks([]);
        }
    }, [filterDay, selectedDate, selectedDates, selectedVenue, selectedVenue.packs, packs, forceUpdateTop, filterDays]);

    useEffect(() => {
        if (selectedPack && selectedVenue && filterDay) {
            // 2026-07-16
            const packVenueRelation = selectedVenue.expense_packs.find((p) => p.id == selectedPack.id);
            if (packVenueRelation && Object.prototype.hasOwnProperty.call(packVenueRelation.pivot.amount, filterDay)) {
                setSelectedAmount(packVenueRelation.pivot.amount[filterDay]);
            } else {
                setSelectedAmount(0);
            }
        }
    }, [selectedVenue, selectedPack, filterDay]);

    const selectPack = (details) => {
        if (details.id == selectedPack.id) {
            return setSelectedPack(false);
        }
        setSelectedPack(() => {
            return packs.find((p) => p.id == details.id);
        });
    };

    const selectVenue = (details) => {
        localStorage.setItem('localselectedVenue', details.id);
        setSelectedVenue(() => {
            return venues.find((v) => v.id == details.id);
        });
    };

    const selectDate = (details) => {
        localStorage.setItem('localselectedDate', details.date);
        setSelectedDate((d) => {
            return details.date;
        });
    };

    const datesKey = () => {
        return props.event.id + '_localselectedDates';
    };

    const selectDates = (details, reset = true) => {
        let resultDates = localStorage.getItem(datesKey());
        resultDates = resultDates ? JSON.parse(resultDates) : [];

        if (reset) {
            details.dates.forEach((val) => {
                const str = val.toString();
                const index = resultDates.indexOf(str);

                if (index !== -1) {
                    resultDates.splice(index, 1);
                } else {
                    resultDates.push(str);
                }
            });
        }
        resultDates.sort((a, b) => {
            const formA = moment(a).unix();
            const formB = moment(b).unix();

            return formA - formB;
        });

        localStorage.setItem(datesKey(), JSON.stringify(resultDates));
        setSelectedDates((d) => {
            return resultDates;
        });
    };

    const clearDates = (details) => {
        localStorage.setItem(datesKey(), JSON.stringify([]));
        setSelectedDates((d) => {
            return [];
        });
    };

    /** Collapse multi-date selection to a single day for contractor pack edit/view. Pass preferredDay (YYYY-MM-DD) to keep that day. */
    const selectOnlyFirstDate = (preferredDay) => {
        let resultDates = localStorage.getItem(datesKey());
        resultDates = resultDates ? JSON.parse(resultDates) : [];
        if (resultDates.length <= 1) {
            return;
        }
        resultDates.sort((a, b) => {
            const formA = moment(a).unix();
            const formB = moment(b).unix();
            return formA - formB;
        });
        let dayToKeep = resultDates[0];
        if (typeof preferredDay === 'string' && preferredDay.length) {
            const preferredNormalized = moment(preferredDay, 'YYYY-MM-DD', true).isValid() ? preferredDay : moment(preferredDay).format('YYYY-MM-DD');
            const match = resultDates.find((d) => moment(d).format('YYYY-MM-DD') === preferredNormalized);
            if (match !== undefined) {
                dayToKeep = match;
            }
        }
        const firstOnly = [dayToKeep];
        localStorage.setItem(datesKey(), JSON.stringify(firstOnly));
        const firstDate = new Date(Date.parse(firstOnly[0]));
        setSelectedDates(() => [firstDate]);
        selectDate({ date: firstDate });
    };

    const selectSchedules = (details) => {
        setSelectedSchedules(() => {
            let dates = localStorage.getItem(datesKey());
            dates = dates ? JSON.parse(dates) : [];
            return dates.length === 0 ? [] : details.schedules;
        });
    };

    useEffect(() => {
        if (venues.length) {
            if (props.selectedVenueId > 0 && venues.find((v) => v.id == props.selectedVenueId)) {
                selectVenue({ id: props.selectedVenueId });
            } else if (localStorage.getItem('localselectedVenue') && venues.find((v) => v.id == localStorage.getItem('localselectedVenue'))) {
                selectVenue({ id: localStorage.getItem('localselectedVenue') });
            } else {
                selectVenue({ id: venues[0].id });
            }
        }
    }, [venues.length, forceUpdateTop]);

    useEffect(() => {
        if (selectedVenue) {
            selectDate({ date: new Date(Date.parse(selectedVenue.hire_start)) });
            clearDates();
        }
    }, [selectedVenue]);

    useEffect(() => {
        const formD = moment(selectedDate);
        setFormattedDate(formD.format('DD MMMM YYYY'));
    }, [selectedDate]);

    useEffect(() => {
        const formD = moment(formattedDate);
        setFilterDay(formD.format('YYYY-MM-DD'));
    }, [formattedDate]);

    useEffect(() => {
        const dates = [];
        selectedDates.forEach((val) => {
            const formD = moment(val);
            dates.push(formD.format('DD MMMM YYYY'));
        });
        setFormattedDates(dates);
    }, [selectedDates]);

    useEffect(() => {
        const dates = [];
        formattedDates.forEach((val) => {
            const formD = moment(val);
            dates.push(formD.format('YYYY-MM-DD'));
        });

        setFilterDays(dates);
    }, [formattedDates]);

    useEffect(() => {
        calculateCalendarEvents();
    }, [selectedDate, selectedVenue, selectedDates]);

    const calculateCalendarEvents = () => {
        if (selectedDate && selectedVenue) {
            const events = [];
            const contructors = {};
            const simples = {};
            selectedVenue.expense_packs.forEach((expensePack) => {
                Object.keys(expensePack.pivot.amount).forEach((key) => {
                    if (expensePack.pack_contractor) {
                        if (!(key in contructors)) {
                            contructors[key] = 0;
                        }
                        contructors[key] = Number(contructors[key]) + Number(expensePack.pivot.amount[key]);
                    } else {
                        if (!(key in simples)) {
                            simples[key] = 0;
                        }
                        simples[key] = Number(simples[key]) + Number(expensePack.pivot.amount[key]);
                    }
                });
            });
            for (let i = 0; i < selectedVenue.schedules.length; i++) {
                const sched = selectedVenue.schedules[i];
                const schedDay = moment(sched.start);
                const schedDayFormatted = schedDay.format('YYYY-MM-DD');
                const schedDayIndex = events.findIndex((e) => e.schedDay == schedDayFormatted);
                if (-1 !== schedDayIndex) {
                    events[schedDayIndex].title++;
                    events[schedDayIndex].schedules.push(sched);
                } else {
                    events.push({
                        id: 0,
                        schedDay: schedDayFormatted,
                        count: 1,
                        title: 1,
                        allDay: true,
                        start: schedDay.toDate(),
                        end: schedDay.toDate(),
                        schedules: [sched],
                    });
                }
            }
            const packEvents = {};

            Object.keys(contructors).forEach((key) => {
                if (!(key in packEvents)) {
                    packEvents[key] = 'Cx' + contructors[key];
                } else {
                    packEvents[key] += ' Cx' + contructors[key];
                }
            });
            Object.keys(simples).forEach((key) => {
                if (!(key in packEvents)) {
                    packEvents[key] = 'Sx' + simples[key];
                } else {
                    packEvents[key] += ' Sx' + simples[key];
                }
            });
            Object.keys(packEvents).forEach((key) => {
                const schedDay = moment(key);
                const schedDayFormatted = schedDay.format('YYYY-MM-DD');
                events.push({
                    id: 0,
                    schedDay: schedDayFormatted,
                    count: 1,
                    title: packEvents[key],
                    allDay: true,
                    start: schedDay.toDate(),
                    end: schedDay.toDate(),
                });
            });

            setCalendarEvents(events);
        }
    };

    return (
        <AssignContext.Provider
            value={{
                venues,
                selectedVenue,
                selectedDate,
                selectedDates,
                formattedDate,
                formattedDates,
                filterDay,
                filterDays,
                filteredPacks,
                calendarEvents,
                selectedPack,
                selectedAmount,
                selectedSchedules,
            }}
        >
            <AssignDispatchContext.Provider value={assignAction}>{props.children}</AssignDispatchContext.Provider>
        </AssignContext.Provider>
    );
}

export { AssignProvider, AssignContext, AssignDispatchContext };
